<template>
  <div class="message">
    {{ $l[$store.state.event.status] }}
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ]
}
</script>

<style lang="scss" scoped>
.message {
  @include caption-center;
}
</style>
